module.exports = __webpack_public_path__ + "static/media/folder_open.2a6d646e.ico";